import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { Switch } from '@restworld/ui-ds-base';
import { useCallback, useState } from 'react';
import { useUpdateWorkerPublicShowcaseMutation } from './use-update-worker-public-showcase-mutation';

// TODO: Sostituire con il vero hook dati utente worker
// import { useWorkerUserData, useUpdateWorkerUserNotificationSettings } from '...';

export const UserNotificationPublicShowcaseSwitch = ({
  value,
  loading = false,
}: {
  value: boolean;
  loading?: boolean;
}) => {
  const { t } = useTranslation('user-settings');
  const [localValue, setLocalValue] = useState(value);
  const { mutate, isPending } = useUpdateWorkerPublicShowcaseMutation(setLocalValue);

  const handleSwitch = useCallback(
    (enabled: boolean) => {
      mutate(enabled);
    },
    [mutate]
  );

  return (
    <div className="flex items-center gap-3">
      <span>{t('new_public_showcase_notification_enabled_label')}</span>
      <Switch
        checked={localValue}
        onChange={handleSwitch}
        srOnlyLabel={t('new_public_showcase_notification_enabled_label')}
        disabled={loading || isPending}
      />
      {isPending && <span>...</span>}
    </div>
  );
};
